import React from "react"
import { useIntl } from "react-intl"
import { WarningStep } from "../variants/WarningStep"
import { Link } from "@carrotfertility/carotene-core"
import { Link as RouterLink } from "react-router-dom"
export function CompleteIvfRequirementsStep(): JSX.Element {
  const intl = useIntl()

  return (
    <WarningStep
      title={intl.formatMessage({
        defaultMessage: "You need to complete a few requirements before using Carrot Card."
      })}
      primaryDescription={intl.formatMessage({
        defaultMessage:
          "To support healthy outcomes, additional steps are required before we can authorize IVF-related expenses."
      })}
      secondaryDescription={intl.formatMessage(
        {
          defaultMessage: "Please <link>complete these requirements</link> and then submit your request."
        },
        {
          link: (linkContent) => (
            <Link
              component={RouterLink}
              to="/reimbursements/ivf-requirements"
              color="inherit"
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkContent}
            </Link>
          )
        }
      )}
      tertiaryDescription={intl.formatMessage(
        {
          defaultMessage: "If you have questions, <link>contact us</link>."
        },
        {
          link: (linkContent) => (
            <Link component={RouterLink} to="/care-team" color="inherit" target="_blank" rel="noopener noreferrer">
              {linkContent}
            </Link>
          )
        }
      )}
    />
  )
}
